import {
  MasonryWSDriverNodeRenderersRegistry,
  MasonryDriverNodeRenderersRegistry,
} from '@leagueplatform/masonry';
import { MASONRY, MASONRY_V2 } from 'common/constants';
import { RichTextSection } from 'components/masonry-rich-text/masonry-rich-text.component';
import { PwpHeader } from 'components/pwp/pwp-header.component';
import { PwpPrintButton } from 'components/pwp/pwp-pdf-print-button.component';
import { PWPDisclaimerWidget } from 'pages/pwp/pwp-disclaimer-widget.component';
import { EasyPlanWidget } from 'components/easy-plan/easy-plan-widget-component';
import { HsaPendingBannerWidget } from 'components/hsa-pending-banner/hsa-pending-banner-widget.component';
import { RegionSelectionHome } from 'components/region-selection/containers/region-selection-home';
import { GenericStatusBanner } from 'components/status-banner-masonry-widget/generic-status-banner.component';

export const initMasonryRegistry = () => {
  // Registering overviewText node type to Masonry WS Driver
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.NODE_TYPE_OVERVIEW_TEXT,
    RichTextSection,
  );
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.CUSTOM_WIDGET_TYPE_PWP_HEADER,
    PwpHeader,
  );
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.NODE_TYPE_BUTTON_SECONDARY,
    PwpPrintButton,
  );

  // Registering disclaimer banner node type to Masonry WS Driver
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.CUSTOM_WIDGET_TYPE_PWP_DISCLAIMER,
    PWPDisclaimerWidget,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REGION_BANNER,
    RegionSelectionHome,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_GENERIC_STATUS_BANNER,
    GenericStatusBanner,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_PENDING_HSA,
    HsaPendingBannerWidget,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_EASY_PLAN,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_EASY_PLAN,
    EasyPlanWidget,
  );
};
